module.exports = __webpack_public_path__ + "static/media/calendar.37ca3cda.svg";